"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaClientOnlyFooterContext = exports.SpaFooterContext = void 0;
const react_1 = require("react");
const env_util_1 = require("../../utils/env.util");
exports.SpaFooterContext = (0, react_1.createContext)({
    pageType: '',
    baseURL: 'http://header-footer-spa.use1.demm.dev.chewy.com/app/headerfooterspa',
    mountElemId: '',
    userContext: '',
});
exports.SpaClientOnlyFooterContext = (0, react_1.createContext)({
    pageType: '',
    env: env_util_1.Environment.LOCAL,
    mountElemId: '',
    userContext: '',
    useAbsoluteURL: false,
});
//# sourceMappingURL=spa-footer.context.js.map